<template>
  <div v-bind:class="{ 'form-group': true, 'has-error': this.m_error !== null }">
    <label>{{ field.label }}</label>
    <select
      v-if="!field.allowsMultipleChoice"
      class="form-control"
      @change="onChange"
      :value="getAnswerValueForSelect()"
      :disabled="disabledAttribute"
    >
      <option v-for="o in field.options">{{ o }}</option>
    </select>
    <div class="row" v-if="field.allowsMultipleChoice">
      <div class="col-xs-12" v-for="o in field.options">
        <label class="checkbox-inline">
          <input type="checkbox" v-bind:value="o" v-model="m_fieldAnswer.value" :disabled="disabledAttribute">
          <span v-html="o"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['field', 'fieldAnswer', 'isDisabled'],
    name: 'MultipleChoiceField',
    data () {
      return {
        m_fieldAnswer: {
          fieldUuid: this.field.uuid,
          value: (this.fieldAnswer && this.fieldAnswer.value !== null) ? this.fieldAnswer.value : []
        },
        m_error: null,
        m_rowIndex: this.fieldAnswer.rowIndex
      }
    },
    computed: {
      disabledAttribute () {
        return this.field.disabled === true || this.isDisabled === true
      }
    },
    watch: {
      'm_fieldAnswer.value' () {
        this.$emit('fieldUpdated', this.m_rowIndex, this.m_fieldAnswer)
      }
    },
    methods: {
      getAnswerValueForSelect () {
        return this.m_fieldAnswer.value ? this.m_fieldAnswer.value[0] : null
      },
      onChange (data) {
        this.m_fieldAnswer.value = [data.target.value]
      },
      isValid () {
        if (this.field.required && !this.m_fieldAnswer.value.length) {
          this.m_error = true
          return false
        }
        this.m_error = null
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MultipleChoiceField.vue?0acfcbfb